export default "__VITE_ASSET__CCRG_02$__"